import Axios from "axios";
import {
    SET_BUDGET_TYPE_LIST,
    UNSET_BUDGET_TYPE_LIST,
} from "@/store/mutation-types";
import { 
    budgetTypeResource,
} from "@/store/api";

const state = {
    getBudgetTypeList: [],
};

const getters = {
    getBudgetTypeList(state) {
        return state.getBudgetTypeList;
    },
};

const mutations = {
    [SET_BUDGET_TYPE_LIST](state, data) {
        state.getBudgetTypeList = data;
    },
    [UNSET_BUDGET_TYPE_LIST](state) {
        state.getBudgetTypeList = [];
    },
};

const actions = {
    saveBudgetType({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(budgetTypeResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBudgetType({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${budgetTypeResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBudgetTypeList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(budgetTypeResource)
            .then(function (response) {
            commit('SET_BUDGET_TYPE_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BUDGET_TYPE_LIST');
            reject(error);
            });
        });
    },

    getBudgetTypeById({ commit }, data) {
        const getBudgetTypeRecordById = `${budgetTypeResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBudgetTypeRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

